import { render, staticRenderFns } from "./SFormGroup.vue?vue&type=template&id=a6617a78"
import script from "./SFormGroup.vue?vue&type=script&lang=js"
export * from "./SFormGroup.vue?vue&type=script&lang=js"
import style0 from "./SFormGroup.vue?vue&type=style&index=0&id=a6617a78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports